;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"WeBdiTPtQxdLpasQu9lOO"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from "@sentry/nextjs";
import { SeverityLevel } from "@sentry/nextjs";
import { getEnvironment } from "utils/env";

// Import the toast function
const showSentryToast = (message: string, level = "info") => {
    // Only show toasts in browser environment
    if (typeof window === "undefined") return;

    const toast = document.createElement("div");
    const [eventLevel, ...eventMessageParts] = message
        .split("\n")
        .map((s) => s.trim());
    const eventMessage = eventMessageParts.join("\n");

    toast.innerHTML = `
      <div style="font-size: 0.9em;">${eventLevel}</div>
      <div style="font-size: 1.1em; font-weight: bold;">${eventMessage}</div>
    `;

    const levelColors: Record<SeverityLevel, string> = {
        fatal: "#8B0000", // Dark Red
        error: "#FF0000", // Red
        warning: "#FFA500", // Orange
        info: "#0000FF", // Blue
        debug: "#008000", // Green
        log: "#808080", // Gray
    };

    const backgroundColor =
        levelColors[level as keyof typeof levelColors] || "#808080";

    toast.style.cssText = `
      position: fixed;
      top: 10px;
      right: 10px;
      background-color: ${backgroundColor};
      color: white;
      padding: 12px 24px;
      border-radius: 4px;
      z-index: 9999;
      cursor: pointer;
      max-width: 400px;
      text-align: left;
    `;

    toast.onclick = () => {
        document.body.removeChild(toast);
    };

    document.body.appendChild(toast);
};

const environment = getEnvironment();

// Initialize Sentry for all environments, but with different configurations
Sentry.init({
    environment,
    dsn: "https://40b172a075a2593a73d8a9e1c0501312@o4504452820369408.ingest.us.sentry.io/4509519242919936",
    release: process.env.SENTRY_RELEASE,
    debug: false,

    // Different settings based on environment
    ...(environment === "production"
        ? {
              tracesSampleRate: 1,
              replaysOnErrorSampleRate: 1,
              replaysSessionSampleRate: 0.1,
              profilesSampleRate: 1,
              integrations: [
                  Sentry.replayIntegration({
                      maskAllText: true,
                      blockAllMedia: true,
                  }),
                  Sentry.browserProfilingIntegration(),
              ],
          }
        : {
              // Development/staging settings
              tracesSampleRate: 0.1,
              replaysOnErrorSampleRate: 0,
              replaysSessionSampleRate: 0,
              profilesSampleRate: 0,
              integrations: [
                  Sentry.replayIntegration({
                      maskAllText: false,
                      blockAllMedia: false,
                  }),
              ],
          }),

    beforeSend(event, hint) {
        // Log all events to console for debugging
        const eventLevel = event.level || "info";
        const eventMessage =
            event.message || JSON.stringify(hint.originalException);

        // Show toast in development and localhost environments
        if (
            (environment !== "production" ||
                window.location.hostname === "localhost") &&
            process.env.NEXT_PUBLIC_SHOW_SENTRY_TOAST
        ) {
            const toastMessage = `Sentry ${eventLevel} event:\n${eventMessage}`;
            showSentryToast(toastMessage, eventLevel);
        }

        // In development, don't send to Sentry unless explicitly enabled
        if (
            environment !== "production" &&
            !process.env.NEXT_PUBLIC_SENTRY_ENABLED
        ) {
            return null;
        }

        return event;
    },
});
